import React from "react";
import SolEmperia from "../assets/images/sol-emperia.png";
import SolAdventia from "../assets/images/sol-adventia.png";
import SolEimdp from "../assets/images/sol-eimdp.png";
import SolTdx from "../assets/images/sol-tdx.png";
import { Link } from "react-router-dom";

const HomeSolutions = () => {
  return (
    <div className="home-technology-solutions mt-5">
      <div className="container">
        <h2 className="text-center mb-5">
          Our Enterprise Travel Technology Services
        </h2>
        <div className="row">
          <div className="col-lg-3 mb-3">
            <div className="p-3 text-center ">
              <img
                src={SolEmperia}
                alt="Emperia"
                className="w-100"
                style={{ maxWidth: "121px" }}
              />
              <h5 className="mt-3" style={{ fontWeight: "600" }}>
                Managed Services for Enterprise Travel Systems
              </h5>
              <p className="text-secondary">
                We maintain and operate your existing travel stack — GDS, NDC, and supplier connectivity included. No forced migration. Your infrastructure stays stable while we extend capabilities.
              </p>
              <Link
                to="/solutions/travel-agency-software"
                className="btn btn-sm btn-primary"
              >
                Details
              </Link>
            </div>
          </div>
          <div className="col-lg-3 mb-3">
            <div className="p-3 text-center">
              <img
                src={SolAdventia}
                alt="Adventia"
                className="w-100"
                style={{ maxWidth: "121px" }}
              />
              <h5 className="mt-3" style={{ fontWeight: "600" }}>
                AI Enablement for Your Existing Stack
              </h5>
              <p className="text-secondary">
                Layer analytics and intelligence across your existing travel vertical — search, pricing, automation, back-office workflows. At your pace. Without forcing a platform replacement.
              </p>
              <Link
                to="/solutions/dmc-software"
                className="btn btn-sm btn-primary"
              >
                Details
              </Link>
            </div>
          </div>
          <div className="col-lg-3 mb-3">
            <div className="p-3 text-center">
              <img
                src={SolEimdp}
                alt="E-IMDP"
                className="w-100"
                style={{ maxWidth: "121px" }}
              />
              <h5 className="mt-3" style={{ fontWeight: "600" }}>
                Bespoke Travel Platforms
              </h5>
              <p className="text-secondary">
                Custom-built platforms designed around your exact commercial model, supplier landscape, and operational needs. Delivered as your IP. When off-the-shelf won't fit.
              </p>
              <Link
                to="/solutions/inventory-distribution"
                className="btn btn-sm btn-primary"
              >
                Details
              </Link>
            </div>
          </div>
          <div className="col-lg-3 mb-3">
            <div className="p-3 text-center">
              <img
                src={SolTdx}
                alt="Travel Aggregation"
                className="w-100"
                style={{ maxWidth: "121px" }}
              />
              <h5 className="mt-3" style={{ fontWeight: "600" }}>
                Supplier Integration & API Connectivity
              </h5>
              <p className="text-secondary">
                Unified API aggregation connecting 85+ travel suppliers — GDS, LCCs, hotels, car rentals, activities, and more. Enterprise-grade connectivity expertise.
              </p>
              <Link
                to="/solutions/travel-data-xchange-switch"
                className="btn btn-sm btn-primary"
              >
                Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSolutions;
